type Props = {
  label: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  className?: string;
  leftIcon?: React.ReactNode;
  variant?: "primary" | "secondary" | "link";
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const BaseButton: React.FC<Props> = ({
  label,
  onClick,
  type = "button",
  disabled = false,
  className = "",
  leftIcon,
  variant = "primary",
  ...rest
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    className={`btn btn-${variant} ${className}`}
    {...rest}
  >
    {leftIcon && <span className="btn-icon">{leftIcon}</span>}
    {label}
  </button>
);

export default BaseButton;
